module.exports = __webpack_public_path__ + "img/15.d5bcbc30.png";